export default __webpack_public_path__ + "static/media/tick-green.f9a19cbf.svg";